import urlTemplate from 'url-template';
import type {
  NotificationsParams,
  NotificationsResponse,
} from 'src/apis/notification-service/types';
import type { NotificationServiceRequest } from 'src/apis/notification-service/use-notification-service-root';
import { useAxios, type Successful } from 'src/hooks/use-axios';
import { isConstraintViolation } from 'src/utils/is-constraint-violation';

type HookOptions = {
  notificationService: Successful<NotificationServiceRequest>;
  params: NotificationsParams;
};

export function useNotifications() {
  const notifications = useAxios(
    (axios, baseConfig, { notificationService, params }: HookOptions) => {
      const link =
        notificationService.response.data._links.getNotifications.href;
      return axios.request<NotificationsResponse>({
        ...baseConfig,
        url: urlTemplate.parse(link).expand({}),
        params,
      });
    },
    {
      neededOnPageLoad: true,
      onError(error) {
        if (isConstraintViolation(error)) return error;
        throw error;
      },
    }
  );

  return notifications;
}

export type NotificationsRequest = ReturnType<typeof useNotifications>;
